import { render, staticRenderFns } from "./ReportSlotsCard.vue?vue&type=template&id=68b85ba8"
import script from "./ReportSlotsCard.vue?vue&type=script&lang=ts"
export * from "./ReportSlotsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports